
import { UiButton, UiDashboardSearchInput } from "@/components/ui";
import { Download, Plus } from "lucide-react";
import PageHeading from "../welcome/page.heading";
import { useAuthStore } from "@/context";
import { on } from "events";

interface DashboardHeaderProps {
  subTitle?: string;
  selectSlot?: React.ReactNode;
  downloading?: boolean;
  showButtons?: boolean;
  onDownload?: () => void;
  onUpload?: () => void;
}

export function DashboardHeader({
  selectSlot,
  subTitle,
  downloading,
  showButtons = true,
  onDownload,
}: DashboardHeaderProps) {
  const { currentUser } = useAuthStore();

  return (
    <>
      {showButtons && (
        <div className="flex items-center justify-between mb-4 gap-2 md:gap-4 flex-wrap">
          <UiDashboardSearchInput
            onSubmit={() => {}}
            placeholder="Par ici les recherche..."
          />

          <div className="flex gap-2">
            <UiButton
              className="normal-case"
              color="secondary"
              loading={downloading}
              onClick={onDownload}
              startIcon={<Download />}
            >
              Téléchargement
            </UiButton>
            <UiButton className="normal-case" startIcon={<Plus />}>
              Ajouter un fichier
            </UiButton>
          </div>
        </div>
      )}

      <div className="py-5 flex items-center justify-between">
        <PageHeading
          title={`Bonjour ${currentUser?.prenom ?? ""}`}
          subTitle={subTitle}
        />
        {selectSlot && selectSlot}
      </div>
    </>
  );
}
